export default "__VITE_ASSET__af3e09ff__"